import { useState } from 'react';
// components
import {
  IEditForm,
  CasRadioGroup,
  CasEditForm,
  CasRHFTextField,
  CasRHFSwitch,
  CasRHFPercentField,
  CasRHFCurrencyField,
  CasStackRow,
} from 'src/compass/shared/components';
import {
  CasAsOfContainer,
  EntityInfoLRPAdditCompensation,
  useDefaultAsOfValues,
} from 'src/compass/application/commissions';

// schema
import { AdditSchema } from './LrpCommissionsSchema';

// ----------------------------------------------------------------------

export default function LRPAdditCompensationForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const [asofReadonly, setAsofReadonly] = useState(false);

  const defaultValues = useDefaultAsOfValues(row, { isActive: true });

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity={EntityInfoLRPAdditCompensation.entity}
      schema={AdditSchema}
    >
      <CasStackRow>
        <CasRHFTextField name="description" label="Description" />
        <CasRHFSwitch name="isActive" label="Active" />
      </CasStackRow>

      <CasStackRow>
        <CasRHFTextField name="glAccountInfo" label="G/L Account" />
        <CasRHFTextField name="payrollExportCode" label="Payroll Export Code Override" />
      </CasStackRow>

      <CasAsOfContainer
        entityTitle="Additional Compensation AsOf"
        entityId={id}
        deleteChildEntity="Ins/CompType/AsOf"
        initialAsOfList={row?.asOfs}
        initialAsOf={defaultValues.asOf}
        readOnly={asofReadonly}
        setReadOnly={setAsofReadonly}
      >
        <CasRadioGroup
          name="asOf.rateType"
          disabled={asofReadonly}
          label="Rate"
          spacing={2}
          options={[
            {
              value: 'ratePerHead',
              label: (
                <CasRHFCurrencyField
                  name="asOf.ratePerHead"
                  label="Per Head"
                  disabled={asofReadonly}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              ),
            },
            {
              value: 'ratePercent',
              label: (
                <CasRHFPercentField
                  name="asOf.ratePercent"
                  label="Percent"
                  disabled={asofReadonly}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              ),
            },
          ]}
        />
        <CasRHFSwitch
          name="asOf.only12Months"
          label="Only first 12 months from Grower's first endorsement"
          disabled={asofReadonly}
        />
      </CasAsOfContainer>
    </CasEditForm>
  );
}
